<template>
	<div id="grzl">
		<div class="grzl_main">
			<el-form ref="form" :model="form" label-width="100px">
				<el-form-item label="真实姓名：">
					<el-input v-if="!oldFullName" v-model="form.FullName"></el-input>
					<span v-else>{{ oldFullName }}</span>
				</el-form-item>
				<el-form-item label="昵称：">
					<el-input v-model="form.NickName"></el-input>
				</el-form-item>
				<el-form-item label="QQ：">
					<el-input v-model="form.QqNumber"></el-input>
				</el-form-item>
				<el-form-item label="邮箱号：">
					<el-input v-model="form.Email"></el-input>
				</el-form-item>
				<el-form-item label="手机号：">
					<el-input v-model="form.PhoneNumber"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button class="submit" type="primary" @click="onSubmit">提交</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";
import { Message } from "element-ui";

export default {
	data() {
		return {
			form: {
				QqNumber: "",
				Email: "",
				PhoneNumber: "",
				FullName: "",
				NickName: "",
			},
			oldFullName: "",
		};
	},
	methods: {
		onSubmit() {
			let mailReg = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/;
			if (!mailReg.test(this.form.Email)) {
				this.$message.error("邮箱格式不正确");
				return;
			}

			let that = this;
			let url = "Api/User/UserUpdateInfo";
			if (!/^1[3456789]\d{9}$/.test(this.form.PhoneNumber)) {
				this.$message.error("手机号不合法");
			} else {
				const loading = this.$loading({ background: "rgba(255, 255, 255, 0.2)" });
				postAjax(url, this.form)
					.then(function (data) {
						loading.close();
						if (data.IsSucess) {
							that.getUserInfo();
							that.$message({
								message: "修改成功",
								type: "success",
							});
						} else {
							Message.error(data.Message);
						}
					})
					.catch(() => {
						loading.close();
					});
			}
		},
		//得到个人信息
		// 得到用户信息方法
		getUserInfo() {
			let that = this;
			let url = "Api/User/GetUserInfo";
			postAjax(url, null).then(function (data) {
				if (data.IsSucess) {
					that.form.FullName = data.Data.FullName;
					that.oldFullName = data.Data.FullName;
					that.form.NickName = data.Data.NickName;
					that.form.QqNumber = data.Data.QqNumber;
					that.form.PhoneNumber = data.Data.PhoneNumber;
					that.form.Email = data.Data.Email;
				}
			});
		},
	},
	mounted() {
		this.getUserInfo();
	},
};
</script>
<style lang="scss">
.grzl_main {
	display: flex;
	justify-content: center;
	margin: 42px auto 0;
}

#grzl .el-form-item__label {
	font-size: 14px;
	font-weight: bold;
	letter-spacing: 0;
	color: #171717;
}

/*提交按钮的样式*/
#grzl .submit {
	width: 112px;
	height: 40px;
	color: #fff;
	font-size: 16px;
	line-height: 36px;
	padding: 0;
}

#grzl .el-input {
	width: 320px;
}

/*提示弹窗样式*/
#grzl .el-dialog__body {
	padding: 0;
}

#grzl .el-dialog__footer {
	padding: 25px 0 60px;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/UserComps/grzl.vue